function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import LineSegment from '../../geom/LineSegment';
var MonotoneChainSelectAction = /*#__PURE__*/function () {
  function MonotoneChainSelectAction() {
    _classCallCheck(this, MonotoneChainSelectAction);
    MonotoneChainSelectAction.constructor_.apply(this, arguments);
  }
  return _createClass(MonotoneChainSelectAction, [{
    key: "select",
    value: function select() {
      if (arguments.length === 1) {
        var seg = arguments[0];
      } else if (arguments.length === 2) {
        var mc = arguments[0];
        var startIndex = arguments[1];
        mc.getLineSegment(startIndex, this.selectedSegment);
        this.select(this.selectedSegment);
      }
    }
  }, {
    key: "getClass",
    value: function getClass() {
      return MonotoneChainSelectAction;
    }
  }, {
    key: "interfaces_",
    get: function get() {
      return [];
    }
  }]);
}();
export { MonotoneChainSelectAction as default };
MonotoneChainSelectAction.constructor_ = function () {
  this.selectedSegment = new LineSegment();
};